import { ApolloCache, gql } from '@apollo/client'

import {
  CreateIncidentNoteMediaMutation,
  CreateIncidentNoteMutation,
} from '@/graphql/generated/operations'

export const updateIncidentNotesCache = (
  cache: ApolloCache<any>,
  incidentId: string,
  newNote: CreateIncidentNoteMutation['createIncidentNote']['incidentNote']
) => {
  const incidentCacheId = `Incident:${incidentId}`

  const newNoteRef = cache.writeFragment({
    data: {
      ...newNote,
      media: [],
    },
    fragment: gql`
      fragment NewIncidentNote on IncidentNote {
        id
        message
        media
        __typename
      }
    `,
  })

  cache.modify({
    id: incidentCacheId,
    fields: {
      notes(existingNotesRef = { edges: [] }) {
        const newNoteEdge = {
          __typename: 'IncidentNoteEdge',
          node: newNoteRef,
        }

        return {
          __typename: existingNotesRef.__typename,
          edges: [newNoteEdge, ...existingNotesRef.edges],
        }
      },
    },
  })
}

type CreatedIncidentNoteMedia = NonNullable<
  CreateIncidentNoteMediaMutation['createIncidentNoteMedia']
>['media']

/**
 * Keeps mutation-confirmed attachments on the note when the incident refetch
 * briefly returns stale media data.
 */
export const updateIncidentNoteMediaCache = (
  cache: ApolloCache<any>,
  incidentNoteId: string | undefined,
  media: CreatedIncidentNoteMedia
) => {
  if (!incidentNoteId || !media?.length) return

  const incidentNoteCacheId = cache.identify({
    __typename: 'IncidentNote',
    id: incidentNoteId,
  })
  if (!incidentNoteCacheId) return

  cache.writeFragment({
    data: { media: media.filter(Boolean) },
    fragment: gql`
      fragment IncidentNoteAttachments on IncidentNote {
        media {
          id
          url
          name
          mimeType
        }
      }
    `,
    id: incidentNoteCacheId,
  })
}
